
import moment from "moment";
import React, { useContext } from 'react';
import { FormContext } from 'core/FormProvider';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import FormGroup from 'form/FormGroup';
import { InputWidget } from 'form/InputWidget';
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";
import NullCheckboxWidget from "form/NullCheckbox";
import UploadButton from "form/UploadButton";
import UploadedDocumentItem from "./UploadedDocumentItem";
import {Grid} from "ui/Grid";
import {CheckboxWidget} from "form/Checkbox";
import DateMaskedWidget from "form/DateMaskedWidget";


export default function ClientContractForm() {
  const formContext = useContext(FormContext);
  const { item } = formContext;

  const onAutomaticProlongationChange = (value) => {
		if (value === true) {
			formContext.setDateValue("date_end", moment('2050-01-01'));
		}
		else {
			formContext.setDateValue("date_end", null);
		}
		formContext.setValue("automatic_prolongation", value)
	}

  return (
    <FormGroup>

      <ContextFormControlWidget
        name={'counterparty'}
        WidgetComponent={AsyncAutocompleteWidget}
        widgetProps={{
          label: 'Контрагент',
          url: 'client/counterparty',
          optionLabel: 'name',
          filter: {
            client: item.client
          }
        }}
      />

      <ContextFormControlWidget
        name={'carrier'}
        WidgetComponent={AsyncAutocompleteWidget}
        widgetProps={{
          label: 'Перевозчик',
          url: 'catalog/choice',
          filter: {
            type: 'CARRIER'
          }
        }}
      />

      <ContextWidget
        name={'number'}
        WidgetComponent={InputWidget}
        widgetProps={{
          label: 'Номер договора',
          required: true
        }}
      />

      <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
        <ContextWidget
          name={'date_start'}
          WidgetComponent={DateMaskedWidget}
          widgetProps={{
            label: 'Дата начала действия',
            required: true,
            popperPlacement: 'top-start'
          }}
        />

        {!item.automatic_prolongation && (
          <ContextWidget
            name={'date_end'}
            WidgetComponent={DateMaskedWidget}
            widgetProps={{
              label: 'Дата окончания действия',
              required: true,
              popperPlacement: 'top-start'
            }}
          />
        )}
      </Grid>

      <div className={'mb-10'}>
        <CheckboxWidget
          value={item.automatic_prolongation}
          label={'Автоматическая пролонгация'}
          onChange={(value) => onAutomaticProlongationChange(value)}
        />
      </div>

      <div className={'mb-20'}>
        <NullCheckboxWidget
          value={item.exchanged_originals}
          label={'Обменялись оригиналами'}
          onChange={(value) => formContext.setValue('exchanged_originals', value)}
        />
      </div>

      {item.files.map(file =>
        <UploadedDocumentItem key={item.id} item={file} context={formContext}/>
      )}

      <UploadButton
        url={'client/contract_file'}
        onUploaded={(item) => formContext.pushArrayValue('files', item)}
        data={{
          client_contract: item.id
        }}
      />
    </FormGroup>
  )
}
